module.exports = __webpack_public_path__ + "static/media/bgoverlay.2310f4ba.jpg";